import { hysteriFetch, wrappers } from 'hysterics';
import logger from 'ws-scripts/modules/logger';

// Buffer (ms) on top of the worst-case server time to cover network RTT and
// proxy overhead. The client-side timeout must exceed the server's full WIS
// budget — `serverTimeout * (serverRetries + 1)` — or the client gives up
// before the server can return, wasting work and triggering retries.
const CLIENT_TIMEOUT_BUFFER_MS = 500;

const fetchVehiclesWrapper = hysteriFetch('ws-compare-vehicle-by-uuids');

export default async function fetchVehiclesByUuids({
	uuids,
	siteId,
	locale,
	deviceType,
	pageAlias,
	pageId,
	flags
}) {
	const fetchTimeout = flags['ws-compare-vehicle-fetch-timeout'];
	const fetchRetries = flags['ws-compare-vehicle-fetch-retries'];
	let response;
	try {
		response = await fetchVehiclesWrapper(
			'/api/widget/ws-vehicle-compare/getVehiclesByUuids',
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({
					uuids,
					siteId,
					locale,
					deviceType,
					pageAlias,
					pageId,
					flags
				})
			},
			{
				[wrappers.timeout.contextKey]: {
					timeout:
						fetchTimeout * (fetchRetries + 1) +
						CLIENT_TIMEOUT_BUFFER_MS
				},
				// Server already retries WIS via the same flag; client retrying
				// would compound — each client retry triggers a fresh server
				// retry chain. Keep this at 0.
				[wrappers.retry.contextKey]: { retries: 0 }
			}
		);
	} catch (err) {
		const errorText = `ws-vehicle-compare: Error fetching vehicles by UUIDs. ${err.message}`;
		logger.error(new Error(errorText));
		return [];
	}
	return Array.isArray(response) ? response : [];
}
